<div class="wrapper">
    <header class="main-header">
        <nav class="navbar navbar-static-top">
            <div class="container">
                <div class="navbar-header">
                    <a>
                        <img class="logo-mini navbar-brand" style="padding-top: 2px;height: 52px;padding-right: 10px;"
                            src="assets/img/EY_Logo.png" />
                    </a>
                    <span style="color: white;font-size: 14px;text-align: right"> IT RECOVERY SYSTEM </span> 
                </div>
            </div>
           
        </nav>
    </header>

    <div class="content-wrapper">
        <div class="container">
            <div class="container-fluid" style="padding-top: 150px;">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 logout-body">
                        <div class="row" style="margin-left: 20rem;">
                            <div class="col-md-1" style="margin-top: 35px;">
                                <i class="pi pi-exclamation-triangle" style="color: green; font-size: 5.5rem;"></i>

                            </div>
                            <div class="col-md-10 text-left" style="margin-top: 25px;">
                                <p style="word-wrap:break-word; width:500px">{{ErrorMessage}}</p>
                                <h5>You have been logged out from this application.</h5>
                                <span style="text-decoration: underline"><a (click)="Login()"
                                        style="cursor:pointer;">Please Click Here to Re-login</a> </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>